module.exports = __webpack_public_path__ + "img/PS-900.b5d8e63a.jpg";